<template>
    <div v-if="!openPurchaseView" class="flex flex-col !my-0 mx-24 py-24">
        <div class="mb-24">
            <p class="text-heading-2 font-semibold">{{ $t('multi-posting.tabs.social-boosts.label') }}</p>
        </div>
        <div class="flex">
           <SocialBoostRequest
               class="h-fit sticky top-24"
               @request-booster="requestSocialBoost"
           />
           <SocialBoostGrid
               class="grow"
               @add-to-campaign="addToCampaign"
               @selected-booster="onSelectedBooster"
           />
        </div>
        <popup-modal
            v-if="selectedBooster"
            custom-classes="w-768"
            :text-center="false"
            @close="selectedBooster = null"
            >
            <BoosterDetails :campaignHandler="addToCampaign" :booster="selectedBooster" />
        </popup-modal>
    </div>
    <div v-else class="p-24 !m-0">
        <SocialBoostFormReview
            :job="requestJob"
            :boost="requestBoost"
            @close="endPurchasing"
        >
            <template #basket>
                <Basket
                    :step='4'
                    :includeProgressionButton='false'
                    :allowDelete=false
                    @purchase="purchase"
                />
            </template>
        </SocialBoostFormReview>
    </div>
</template>

<script>
import SimpleButton from "../components/ui/SimpleButton.vue";
import PaidSubscription from "../models/PaidSubscription";
import PopupModal from "../components/ui/PopupModal.vue";
import Loading from "../components/ui/Loading.vue";
import SelectDropdown from "../components/forms/SelectDropdown.vue";
import { mapActions, mapState } from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useNotificationsStore} from '../state/modules/notifications';
import {useAuthenticationStore} from '../state/modules/authentication';
import {useMultiPostingStore} from '../state/modules/multiPosting';
import { ADD_NOTIFICATION } from "../state/mutation-types";
import SocialBoostRequest from "../components/multiposting/form/SocialBoostRequest.vue";
import SocialBoostGrid from "../components/multiposting/form/SocialBoostGrid.vue";
import BoosterDetails from "../components/multiposting/BoosterDetails.vue";
import SocialBoostFormReview from "../components/multiposting/SocialBoostFormReview.vue";
import Basket from "../components/multiposting/form/Basket.vue";
import * as booster from '../services/BoosterService';

export default {
    name: 'SocialBoosts',
    components: {
        SelectDropdown,
        Loading,
        PopupModal,
        SimpleButton,
        SocialBoostRequest,
        SocialBoostGrid,
        BoosterDetails,
        SocialBoostFormReview,
        Basket
    },
    data() {
        return {
            selectedBooster: null,
            openPurchaseView: false,
            requestBoost: null,
            requestJob: null,
        }
    },
    computed: {
        ...mapState(useMainStore, ['selectedLocale']),
        ...mapState(useAuthenticationStore, ['currentUser']),
        locale() {
            return this.selectedLocale;
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        ...mapActions(useMultiPostingStore, ['purchaseSocialBoost', 'addSelectedItems',
            'clearSelectedItems', 'setPurchasing']),
        onSelectedBooster: function(booster) {
            this.selectedBooster = booster;
        },
        addBooster(booster) {
            if (!booster || !booster.id) {
                return;
            }
            this.addSelectedItems([{
                id: booster.id,
                name: booster.title[this.locale],
                duration: {
                    period: booster.duration
                },
                price: {
                    amount: booster.price,
                    currency: 'EUR'
                },
                type: 'socialChannel',
            }]);
        },
        addToCampaign(booster) {
            this.addBooster(booster);
            this.$emit('change-tab', {tab: 'Campaigns', params: 'create'});
        },
        requestSocialBoost({socialBoost, job}) {
            this.requestBoost = socialBoost;
            this.requestJob = job;
            this.clearSelectedItems();
            this.addBooster(socialBoost);
            this.openPurchaseView = true;
        },
        endPurchasing() {
            this.openPurchaseView = false
            this.setPurchasing(false)
            this.clearSelectedItems()
        },
        purchase() {
            this.setPurchasing(true)
            booster.requestBooster(this.currentUser.id, {
                data: {
                    job: this.requestJob.id,
                    booster: this.requestBoost,
                },
            }).then(() => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('boosters.request_success', {type: this.requestBoost.title[this.locale]}),
                });
            }).finally(() => {
                this.endPurchasing()
            }).catch(() => {
                this.endPurchasing()
            })
        }
    }
}
</script>
